var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn px-8 font-bold uppercase text-sm",class:{ 'btn-primary': _vm.status === 'accept', 'btn-line rounded-full': _vm.status === 'cancel' },on:{"click":_vm.attemptStatusChange}},[_vm._v("\n    "+_vm._s(_vm.label)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }